// PHASE 2: How would you describe your design personality?
import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../../hooks/useUpdateMode'
import { saveAnswer } from '../../../utils/onboardingStorage'

const QUESTION_KEY = 'designIdentity'

const OPTIONS = [
  {
    value: 'Bold trendsetter',
    translationKey: 'pages.onboarding.v2.designIdentity.options.trendsetter',
    emoji: '🔥',
  },
  {
    value: 'Classic traditionalist',
    translationKey: 'pages.onboarding.v2.designIdentity.options.traditionalist',
    emoji: '🏛️',
  },
  {
    value: 'Cozy nester',
    translationKey: 'pages.onboarding.v2.designIdentity.options.nester',
    emoji: '🐦',
  },
  {
    value: 'Minimalist curator',
    translationKey: 'pages.onboarding.v2.designIdentity.options.minimalist',
    emoji: '✨',
  },
  {
    value: 'Eclectic collector',
    translationKey: 'pages.onboarding.v2.designIdentity.options.collector',
    emoji: '🎭',
  },
  {
    value: 'Still figuring it out',
    translationKey: 'pages.onboarding.v2.designIdentity.options.exploring',
    emoji: '🔍',
  },
]

export default function DesignIdentityPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && OPTIONS.some((option) => option.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const value = formData.get('answer') as string

    if (!value) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'How would you describe your design personality?',
      answer_key: value,
      answer: value,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  const buttons = OPTIONS.map((option) => ({
    text: `${option.emoji} ${t(option.translationKey)}`,
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.v2.designIdentity.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      headingSize="text-3xl text-center whitespace-pre-line"
      buttonTextSize="text-xl"
      buttonBgColor="bg-white"
      preselectedValue={preselectedValue}
    />
  )
}
